import { useCallback, useState } from 'react';

const REPAIR_QUEUE_START_HINT_KEY = 'pipeex-validation-repair-queue-start-hint-v1';

export function useValidationRepairQueueHint() {
  const [repairQueueHintDismissed, setRepairQueueHintDismissed] = useState(() => {
    try {
      return window.sessionStorage.getItem(REPAIR_QUEUE_START_HINT_KEY) === '1';
    } catch {
      return false;
    }
  });

  const dismissRepairQueueHint = useCallback(() => {
    try {
      window.sessionStorage.setItem(REPAIR_QUEUE_START_HINT_KEY, '1');
    } catch {
      // ignore
    }
    setRepairQueueHintDismissed(true);
  }, []);

  return { repairQueueHintDismissed, dismissRepairQueueHint };
}
